import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CustomLoader from "./loader";

const MobileApp = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    let page = queryParams.get("page");
    const queryString = queryParams.toString();

    const deepLink = `com.mobiguest.businessmanager://${page}?${queryString}`;
    const fallbackURL = `https://mobiguestmanager.web.app/${page}?${queryString}`;

    if (
      navigator.userAgent.match(
        /(iPhone|iPod|iPad|Android|BlackBerry|IEMobile)/
      )
    ) {
      let fallbackTimeout;

      window.location.href = deepLink;

      fallbackTimeout = setTimeout(() => {
        window.location.href = fallbackURL;
      }, 2000);

      const handleBlur = () => clearTimeout(fallbackTimeout);
      window.addEventListener("blur", handleBlur);

      return () => {
        window.removeEventListener("blur", handleBlur);
      };
    } else {
      window.location.href = fallbackURL;
    }
  }, [navigate]);

  return (
    <div style={{ width: "100%", alignItems: "center" }}>
      <CustomLoader />
    </div>
  );
};

export default MobileApp;
